import { ClockCounterClockwise } from '@phosphor-icons/react';
import { useSceneStore } from '../../stores/sceneStore';

export default function UndoHistoryPanel() {
  const { undoStack, undoLabels, undo, redo, redoStack } = useSceneStore();

  if (undoStack.length === 0 && redoStack.length === 0) {
    return (
      <div className="px-4 py-3 text-[11px] font-sans text-text-tertiary italic">
        No history yet — make an edit to start tracking.
      </div>
    );
  }

  return (
    <div className="overflow-y-auto max-h-[240px]">
      {/* Current state (always at top) */}
      <div className="flex items-center gap-2 px-3 py-1.5 bg-accent-muted border-l-2 border-accent">
        <span className="text-[10px] font-mono text-accent font-semibold">● Current</span>
      </div>

      {/* Undo stack entries (most recent first) */}
      {undoStack.map((_, i) => (
        <button
          key={i}
          onClick={() => {
            for (let k = 0; k <= i; k++) undo();
          }}
          className="w-full flex items-center gap-2 px-3 py-1.5 text-left hover:bg-bg-hover transition-colors group"
        >
          <ClockCounterClockwise size={10} className="text-text-tertiary group-hover:text-text-primary shrink-0" />
          <span className="text-[11px] font-sans text-text-secondary group-hover:text-text-primary truncate">
            {undoLabels[i] ?? `Edit ${undoStack.length - i}`}
          </span>
          <span className="ml-auto text-[9px] font-mono text-text-tertiary shrink-0">
            #{undoStack.length - i}
          </span>
        </button>
      ))}

      {/* Redo entries (if any) */}
      {redoStack.length > 0 && (
        <>
          <div className="border-t border-border-subtle/50 my-1" />
          <p className="px-3 py-1 text-[9px] font-mono text-text-tertiary uppercase tracking-widest">Redo history</p>
          {redoStack.map((_, i) => (
            <button
              key={`r${i}`}
              onClick={() => {
                for (let k = 0; k <= i; k++) redo();
              }}
              className="w-full flex items-center gap-2 px-3 py-1.5 text-left hover:bg-bg-hover transition-colors group opacity-50 hover:opacity-80"
            >
              <span className="text-[11px] font-sans text-text-tertiary group-hover:text-text-secondary truncate">
                {`Redo ${i + 1}`}
              </span>
            </button>
          ))}
        </>
      )}
    </div>
  );
}
